import React from "react";

function Header({customADL, setCustomADL}) {
  return (
    <>
      <header className="d-flex align-items-center">
        <a href="/">
          <img
            src="dist/img/icici_logo.webp"
            alt="ICICI Bank Logo"
            width={252}
            height={50}
            className="img-fluid"
          />
        </a>
        {/* <h2>Savings Account </h2> */}
      </header>
    </>
  );
}

export default Header;
